import { POND_TYPES } from './consts';

export const checkPondTypeLabel = (type) => ([POND_TYPES.BERCARIO, POND_TYPES.PRE_BERCARIO, POND_TYPES.TANQUE_REDE].includes(type) ? 'm³' : 'm²');

export const checkPondType = (type) => [POND_TYPES.BERCARIO, POND_TYPES.PRE_BERCARIO, POND_TYPES.TANQUE_REDE].includes(type);
